<template>
  <div class="change-password main-bg">
    <page-header title="修改密码" style="margin-bottom: 20px" />
    <el-form ref="ruleFormRef" :model="ruleForm" status-icon :rules="rules" label-position="left" label-width="100px" style="width: 500px">
      <el-form-item label="原密码" prop="oldPassword">
        <el-input v-model="ruleForm.oldPassword" show-password clearable placeholder="请输入原密码" type="password" autocomplete="newpassword" />
      </el-form-item>
      <el-form-item label="密码" prop="pass">
        <el-input v-model="ruleForm.password" show-password clearable placeholder="请输入密码" type="password" autocomplete="newpassword" />
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input v-model="ruleForm.rePassword" show-password clearable placeholder="请再次输入密码" type="password" autocomplete="newpassword" />
      </el-form-item>

      <el-form-item>
        <ol class="tips-list">
          <li>密码必须由字母、数字、特殊符号组成，区分大小写</li>
          <li>特殊符号包含除了字母、数字符外的所有字符</li>
          <li>密码长度为8-20位</li>
        </ol>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { ref } from 'vue'
import API from '@/api'
import { Message } from 'element-ui'
import Store from '@/store'

const ruleFormRef = ref()

function validatePass(rule, value, callback) {
  if (value === '') {
    callback(new Error('请输入密码'))
  } else {
    if (ruleForm.value.checkPass !== '') {
      ruleFormRef.value.validateField('checkPass')
    }
    callback()
  }
}

function validatePass2(rule, value, callback) {
  if (value === '') {
    callback(new Error('请再次输入密码'))
  } else if (value !== ruleForm.value.pass) {
    callback(new Error('两次输入密码不一致!'))
  } else {
    callback()
  }
}
const ruleForm = ref({
  oldPassword: '',
  password: '',
  rePassword: ''
})

const rules = ref({
  oldPassword: {
    required: true,
    message: '请输入原密码',
    trigger: 'blur'
  },
  pass: [
    {
      required: true,
      validator: validatePass,
      trigger: 'blur'
    }
  ],
  checkPass: [
    {
      required: true,
      validator: validatePass2,
      trigger: 'blur'
    }
  ]
})

async function submitForm(formName) {
  await formName.validate((valid, fields) => {
    if (valid) {
      API.ChangePassWord(ruleForm.value).then(res => {
        if (+res.code === 200) {
          Message.success('密码修改成功！')
          Store.dispatch('user/Logout')
        }
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}
</script>

<style scoped>
.tips-list {
  font-size: 12px;
  color: #bbb;
  padding: 0 15px;
  line-height: 20px;
}
</style>
